import React from 'react';
import {Col} from 'react-bootstrap';
export const ProjectCard = ({title, description, imgUrl, gitUrl, liveUrl}) =>{
    return (
        <>
        <Col sm={6} md={4}>
        
        <div className='proj-imgbx p-2'>
         <img src={imgUrl} alt='' style={{height: '245px'}}/>
         <div className='pro-txtx mt-2 p-2'>
         <h4>{title}</h4>
         <span>{description}</span>
         
         </div>
        
        </div>
        <p className=''>
        <a type="button" href={gitUrl} target='main' className="btn btn-success">Source Code</a>
        <a type="button" href={liveUrl} target='main' className="btn btn-danger mx-2 my-2">Live</a>
         </p>
        </Col>
        </>
    )
}
